import React, { useEffect } from 'react';
import '../theme.css';
import { useTheme } from '../context/ThemeContext';

const NewLayout = ({ children }) => {
  const { setIsDarkTheme } = useTheme();

  useEffect(() => {
    const visibleSections = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        let changed = false;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleSections.add(entry.target);
            changed = true;
          } else {
            if (visibleSections.has(entry.target)) {
              visibleSections.delete(entry.target);
              changed = true;
            }
          }
        });
        if (changed) {
          setIsDarkTheme(visibleSections.size > 0);
        }
      },
      { rootMargin: '-50% 0px -50% 0px' }
    );

    const checkAndObserve = () => {
      document.querySelectorAll('.dark-section').forEach((el) => {
        if (!el._observed) {
          observer.observe(el);
          el._observed = true;
        }
      });
    };
    checkAndObserve();

    const mo = new MutationObserver(checkAndObserve);
    mo.observe(document.body, { childList: true, subtree: false });

    return () => {
      observer.disconnect();
      mo.disconnect();
    };
  }, [setIsDarkTheme]);

  return (
    <div className="v2-app">
      <div className="v2-main-content">
        {children}
      </div>
    </div>
  );
};

export default NewLayout;
